import { library } from "@fortawesome/fontawesome-svg-core";
// Import only the three icons actually used in the app (FA v6 canonical names).
// This replaces the previous full-pack import (fab + far + fas) which added ~400 KB.
import {
  faCircleNotch,
  faTriangleExclamation,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import "./i18n";

library.add(faCircleNotch, faTriangleExclamation, faMagnifyingGlass);

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
